<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc1"><a href="#/foreword">Foreword</a></p>
<p class="toc2"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc3">  <a href="#/chapter01">1.  Few Strangers, Fewer Secrets</a></p>
<p class="toc">  <a href="#/chapter02">2.  Bad Blood</a></p>
<p class="toc">  <span href="#/chapter03" title="Link target outside of Sample">3.  Trail of Guilt</span></p>
<p class="toc">  <span href="#/chapter04" title="Link target outside of Sample">4.  Inmate #12673</span></p>
<p class="toc">  <span href="#/chapter05" title="Link target outside of Sample">5.  Charlestown State Prison, 1900–1914</span></p>
<p class="toc">  <span href="#/chapter06" title="Link target outside of Sample">6.  Seeking Freedom and Forgiveness</span></p>
<p class="toc">  <span href="#/chapter07" title="Link target outside of Sample">7.  Into Heaven and Hell</span></p>
<p class="toc">  <span href="#/chapter08" title="Link target outside of Sample">8.  We Believe He Is an Unsafe Man</span></p>
<p class="toc">  <span href="#/chapter09" title="Link target outside of Sample">9.  Let Me, for Once, Breathe Free Air</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">10.  A Plea for Mercy</span></p>
<p class="toc"><span href="#/chapter11" title="Link target outside of Sample">11.  Without a Backward Glance</span></p>
<p class="toc1"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3082a6f7